module.exports = __webpack_public_path__ + "resources/checkmark-2fca57110a4335282448bdc72c9fca49.svg";